import { IVisaPrepForm } from '../../../../../../types';
import { isPersonTravellingWith } from '../../../../../../utilities/pages';

type Fields = Pick<
  IVisaPrepForm,
  | 'hasFathersPersonalDetails'
  | 'fatherNationality'
  | 'fatherSameNationality'
  | 'fatherFamilyName'
  | 'fatherGivenName'
  | 'fatherDob'
  | 'fatherPlaceOfBirth'
  | 'fatherTravellingWith'
  | 'fatherUkVisa'
  | 'fatherHasPassport'
  | 'fatherPassportNumber'
>;

type Params = Fields & {
  dobError: string;
};

export function getPageStatus({
  hasFathersPersonalDetails,
  fatherNationality,
  fatherSameNationality,
  fatherFamilyName,
  fatherGivenName,
  fatherDob,
  fatherPlaceOfBirth,
  fatherTravellingWith,
  fatherUkVisa,
  fatherHasPassport,
  fatherPassportNumber,
  dobError,
}: Params): { complete: boolean } {
  let complete = true;

  if (
    hasFathersPersonalDetails === undefined ||
    (hasFathersPersonalDetails === true &&
      (fatherNationality === undefined ||
        fatherNationality === '' ||
        fatherSameNationality === undefined ||
        fatherFamilyName === undefined ||
        fatherFamilyName === '' ||
        fatherGivenName === undefined ||
        fatherGivenName === '' ||
        fatherDob === undefined ||
        fatherDob === '' ||
        fatherPlaceOfBirth === undefined ||
        fatherPlaceOfBirth === '' ||
        fatherTravellingWith === undefined ||
        fatherTravellingWith === '' ||
        (isPersonTravellingWith(fatherTravellingWith) &&
          (fatherUkVisa === undefined ||
            fatherHasPassport === undefined ||
            (fatherHasPassport === true && (fatherPassportNumber === undefined || fatherPassportNumber === '')))) ||
        dobError !== ''))
  ) {
    complete = false;
  }

  return { complete };
}
